import {AfterViewInit, Component,  HostListener, ElementRef, OnDestroy, Input, OnInit, ViewChild} from '@angular/core';
import {Observable,fromEvent, from, Subscription} from "rxjs";
import {ActivatedRoute, Params} from '@angular/router';
 import { HttpEvent, HttpEventType } from '@angular/common/http';
 

import {StreamsService}  from "../../../shared/services/streams.service";
import {StreamProject} from "../../../shared/interfaces";
import {switchMap, map, delay} from 'rxjs/operators'; 
import { NbDialogRef } from '@nebular/theme';
 
@Component({
  selector: 'app-modal-upload-video',
  templateUrl: './modal-upload-video.component.html',
  styleUrls: ['./modal-upload-video.component.scss'],
})
export class ModalUploadVideoComponent implements OnInit, OnDestroy{

  currentMode  = 0;
  uploadingProccess: number = 0
  mode: any = {
	initial:0,
	filePut:1,
	loading:2,
	done: 3

  }
  uploadError:boolean = false
loadingCanceled:boolean = false
  file:File

  upload$ = null
   
  @Input() video: StreamProject;
  @Input() socket: any;
  
 @HostListener('window:beforeunload', ['$event'])  onBeforeUplod($event) {
    if(this.currentMode === this.mode.loading) { this.cancelLoading() }
  }

   constructor(
    public streamsService: StreamsService  ,
    protected ref: NbDialogRef<ModalUploadVideoComponent>
    
    ){
 
  }
  ngOnInit() { 
     
  }


  startUpload(){


     // return

  	this.currentMode = this.mode.loading
	this.uploadError = false
	this.loadingCanceled = false
 
	this.uploadingProccess = 0
	 if(this.upload$){
    		this.upload$.unsubscribe()
	}

	this.upload$ = this.streamsService.uploadVideo(this.video, this.file, this.onUploadError.bind(this))
	.subscribe((event: HttpEvent<any>) => {

		switch (event.type) {
			case HttpEventType.Sent: 
			           this.socket.emit('uploadStarted')
			  break;
			case HttpEventType.ResponseHeader:
			  break;
			case HttpEventType.UploadProgress:
			  this.uploadingProccess = Math.round(event.loaded / event.total * 100);
			  break;
			case HttpEventType.Response:{
			 this.currentMode = this.mode.done 
			 this.socket.emit('uploadDone')
			 this.closeModal()
			  
			}

	      }
   	 })



 
  }

  cancelLoading(){

 
	if(this.upload$){
		this.upload$.unsubscribe()
	 }
		this.uploadError = false
		this.currentMode = this.mode.initial	
		this.loadingCanceled = true 	
		this.uploadingProccess = 0
		this.socket.emit('uploadCanceled')
 }


  

  onUploadError(error){
	 

	this.uploadError = true
        	this.loadingCanceled = false
	if(this.upload$){
    		this.upload$.unsubscribe()
	}
			this.uploadingProccess = 0
	  	this.currentMode = this.mode.initial
 		this.socket.emit('uploadError')
  }


/*  checkDuration(){

	var video = document.createElement('video');
	  video.preload = 'metadata';

	  video.onloadedmetadata = function() {
	    window.URL.revokeObjectURL(video.src);
	    var duration = video.duration;
	    alert('Продолжительность '  + duration + 'сек')
	  }

	  video.src = window.URL.createObjectURL(this.file);;

   } */
  

  fileChange(fileInput){

	this.currentMode = this.mode.filePut
	this.file = fileInput.files[0]

	// this.checkDuration()

		
	this.uploadError = false
	this.loadingCanceled = false
 }

  closeModal() {
    this.ref.close();
  }

   
  
   ngOnDestroy() { 
	if(this.upload$){
    		this.upload$.unsubscribe()
	}
   }
 
   
  
}
